import { PageSize } from './PageSize';
import { PageNumbers } from './PageNumbers';

import { PaginationProps } from './Pagination.types';
import { PageSizeProps } from './PageSize/PageSize.types';

export type { PaginationProps } from './Pagination.types';

export const Pagination = ({
  onPageSizeSelect = () => {},
  onPageSelect = () => {},
  pageSize = 1,
  currentPage = 1,
  totalPages = 1,
  totalRecords = 1,
  pageSizeOptions,
  isInfinite = false,
  isNextPageAvailable = true,
}: PaginationProps) => {
  const handlePageSizeSelect: PageSizeProps['onPageSizeSelect'] = (pageSize) => {
    onPageSizeSelect(pageSize);
    onPageSelect(1);
  };

  return (
    <div className="grid grid-cols-2 items-center gap-2">
      <PageSize
        pageSize={pageSize}
        onPageSizeSelect={handlePageSizeSelect}
        pageSizeOptions={pageSizeOptions}
        isInfinite={isInfinite}
        totalRecords={totalRecords}
      />

      <PageNumbers
        currentPage={currentPage}
        isInfinite={isInfinite}
        totalPages={totalPages}
        onPageSelect={onPageSelect}
        isNextPageAvailable={isNextPageAvailable}
      />
    </div>
  );
};
